import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=4def0086&scoped=true&"
import script from "./Income.vue?vue&type=script&lang=js&"
export * from "./Income.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/widgets.css?vue&type=style&index=0&id=4def0086&scoped=true&lang=css&"
import style1 from "./Income.vue?vue&type=style&index=1&id=4def0086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4def0086",
  null
  
)

export default component.exports